import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import { Footer, Nav, ScrollToTop, useDocumentTitle } from "./components/Chrome";
import Home from "./pages/Home";
import RulePage from "./pages/RulePage";
import Essay from "./pages/Essay";
import Gatherings from "./pages/Gatherings";
import GatheringDetail from "./pages/GatheringDetail";
import Visit from "./pages/Visit";
import Circles from "./pages/Circles";
import Join from "./pages/Join";
import RsvpManage from "./pages/RsvpManage";
import Admin from "./pages/Admin";

function NotFound() {
  useDocumentTitle("Not found");
  return (
    <>
      <Nav />
      <header className="page-head">
        <div className="prose">
          <p className="eyebrow sc">
            <span className="num">&middot;</span>
            <span>Nothing here</span>
          </p>
          <h1>That page isn&rsquo;t part of the shape.</h1>
          <p className="standfirst">
            The link may be mistyped, or it may be something we&rsquo;ve taken
            down.
          </p>
        </div>
      </header>
      <section data-testid="notfound">
        <div className="prose">
          <div className="actions" style={{ marginTop: 0 }}>
            <Link to="/" className="act">
              Back to the front door &rarr;
            </Link>
            <Link to="/gatherings" className="linkish">
              See what&rsquo;s on
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div id="progress" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rule" element={<RulePage />} />
        <Route path="/rule/why" element={<Essay />} />
        <Route path="/gatherings" element={<Gatherings />} />
        <Route path="/gatherings/:id" element={<GatheringDetail />} />
        <Route path="/visit" element={<Visit />} />
        <Route path="/circles" element={<Circles />} />
        <Route path="/join" element={<Join />} />
        <Route path="/rsvp/:token" element={<RsvpManage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
